import React, { useState, useEffect } from "react";
import { useForm } from 'react-hook-form';

// components
import {
    Button, Card, CardBody, CardHeader, FormGroup, Form, Input, Row, Col, Nav,
    NavItem, NavLink, TabPane, TabContent
} from "reactstrap";
import Select from 'react-select'
import Switch from "react-switch";


// services
import { showMessage } from "../../services/message.js";
import { api_GET, api_POST, api_PUT } from "../../services/api_service.js";
import ValidaAcessoFuncionalidadeAcao from "../../services/acesso.js";

import { useAuth } from "../../context/auth";

export default function PerfilForm({ item, handleReturn }) {
    const {session, setLoading} = useAuth();

    const { register, handleSubmit, errors, setError, setValue, clearErrors, getValues } = useForm({ mode: "onBlur" });

    const [permiteEditar, set_permiteEditar] = React.useState(false);

    const [perfil_Id, set_perfil_Id] = React.useState(0);

    // Status
    const [status, set_status] = React.useState("");
    const [options_status] = React.useState([
        { value: "Ativo", label: "Ativo" },
        { value: "Inativo", label: "Inativo" },
    ]);
    const handleStatus = (value) => {
        set_status(value);
        setValue("status", value, true);
        clearErrors("status");
    }

    // Tipo
    const [tipo, set_tipo] = React.useState("");
    const [options_tipo] = React.useState([
        { value: "Gestor", label: "Gestor" },
        { value: "Responsável", label: "Responsável" }
    ]);
    const handleTipo = (value) => {
        set_tipo(value);
        setValue("tipo", value, true);
        clearErrors("tipo");
    }

    // Permissões de Acesso às telas
    const [list_funcionalidades, set_list_funcionalidades] = React.useState([]);
    const loadListFuncionalidades = () => {
        api_GET('usuario/getfuncionalidades')
            .then(result => {
                let funcionalidades = result.data;
                if (item != null) {
                    for (var i in funcionalidades) {
                        for (var j in funcionalidades[i].funcionalidadeAcoes) {
                            if (item.perfilFuncionalidadeAcao.filter(f => f.autorizado == true
                                && f.funcionalidadeAcao_Id == funcionalidades[i].funcionalidadeAcoes[j].funcionalidadeAcao_Id).length > 0) {
                                funcionalidades[i].funcionalidadeAcoes[j].autorizado = true;
                            }
                        }
                    }
                }

                set_list_funcionalidades(funcionalidades);

            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }
    const handleChangeFuncionalidadeAcao = (funcionalidadeAcao, checked) => {
        funcionalidadeAcao.autorizado = checked;
        let funcionalidade = list_funcionalidades.filter(f => f.funcionalidade_Id == funcionalidadeAcao.funcionalidade_Id)[0];

        let new_funcionalidadeAcao = [];
        funcionalidade.funcionalidadeAcoes.map(m => {
            if (m.fucionalidadeAcao_Id == funcionalidadeAcao.funcionalidadeAcao_Id)
                new_funcionalidadeAcao.push(funcionalidadeAcao);
            else
                new_funcionalidadeAcao.push(m);
        });

        funcionalidade.funcionalidadeAcoes = new_funcionalidadeAcao;

        let new_list = [];
        list_funcionalidades.map(m => {
            if (m.funcionalidade_Id == funcionalidade.funcionalidade_Id)
                new_list.push(funcionalidade);
            else
                new_list.push(m);
        });
        set_list_funcionalidades(new_list);
    }
    const handleSalvarPermissoes = () => {
        if (perfil_Id == 0) {
            showMessage("Aviso", "Salve os dados do perfil antes de liberar as permissões!", 'error', null);
            return;
        }

        let perfil_permissoes = [];

        list_funcionalidades.map(f => {
            if (f.funcionalidadeAcoes != null) {
                f.funcionalidadeAcoes.map(a => {
                    if (a.autorizado) {
                        perfil_permissoes.push({
                            perfil_Id: perfil_Id,
                            funcionalidadeAcao_Id: a.funcionalidadeAcao_Id,
                            autorizado: a.autorizado
                        });
                    }
                })
            }
        })

        if (perfil_permissoes.length == 0) {
            showMessage("Aviso", "Informe pelo menos uma permissão de acesso!", 'error', null);
            return;
        }

        let json_submit = {
            perfil_Id: perfil_Id,
            usuarioUltimaAlteracao_Id: session.usuario_Id,
            perfilFuncionalidadeAcao: perfil_permissoes
        }

        setLoading(true);
        api_POST('perfil/PostPermissoes', json_submit)
            .then(result => showMessage("Aviso", "Operação executada com sucesso!", 'success', null))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    // Permissões de Acesso ao Setup Solicitação Ação
    const [list_setupsolicitacao, set_list_setupsolicitacao] = React.useState([]);
    const loadListSetupSolicitacaoAcao = () => {
        api_GET('setupsolicitacao')
            .then(result => {
                let setup = result.data;
                if (item != null) {
                    for (var i in setup) {
                        for (var j in setup[i].solicitacaoAcoes) {
                            if (item.perfilSetupSolicitacaoAcao.filter(f => f.liberado == true
                                && f.setupSolicitacaoAcao_Id == setup[i].solicitacaoAcoes[j].setupSolicitacaoAcao_Id).length > 0) {
                                setup[i].solicitacaoAcoes[j].liberado = true;
                            }
                        }
                    }
                }
                set_list_setupsolicitacao(setup);
            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }
    const handleChangeSetupSolicitacao = (setupSolicitacaoAcao, checked) => {
        setupSolicitacaoAcao.liberado = checked;
        let setup = list_setupsolicitacao.filter(f => f.setupSolicitacao_Id == setupSolicitacaoAcao.setupSolicitacao_Id)[0];

        let new_setupSolicitacaoAcao = [];
        setup.solicitacaoAcoes.map(m => {
            if (m.setupSolicitacaoAcao_Id == setupSolicitacaoAcao.setupSolicitacaoAcao_Id)
                new_setupSolicitacaoAcao.push(setupSolicitacaoAcao);
            else
                new_setupSolicitacaoAcao.push(m);
        });

        setup.solicitacaoAcoes = new_setupSolicitacaoAcao;

        let new_list = [];
        list_setupsolicitacao.map(m => {
            if (m.setupSolicitacao_Id == setupSolicitacaoAcao.setupSolicitacao_Id)
                new_list.push(setup);
            else
                new_list.push(m);
        });
        set_list_setupsolicitacao(new_list);
    }
    const handleSalvarSetupSolicitacao = () => {
        if (perfil_Id == 0) {
            showMessage("Aviso", "Salve os dados do perfil antes de liberar as permissões!", 'error', null);
            return;
        }

        let perfil_setupsolicitacaoacao = [];

        list_setupsolicitacao.map(f => {
            if (f.solicitacaoAcoes != null) {
                f.solicitacaoAcoes.map(a => {
                    if (a.liberado) {
                        perfil_setupsolicitacaoacao.push({
                            perfil_Id: perfil_Id,
                            setupSolicitacaoAcao_Id: a.setupSolicitacaoAcao_Id,
                            liberado: a.liberado
                        });
                    }
                })
            }
        })

        let json_submit = {
            perfil_Id: perfil_Id,
            usuarioUltimaAlteracao_Id: session.usuario_Id,
            perfilSetupSolicitacaoAcao: perfil_setupsolicitacaoacao
        }

        setLoading(true);
        api_POST('perfil/PostSetupSolicitacaoAcoes', json_submit)
            .then(result => showMessage("Aviso", "Operação executada com sucesso!", 'success', null))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const Voltar = (event, rowData) => {
        handleReturn();
    }

    const [h1_tab, set_h1_tab] = useState("ht1");

    const loadItem = () => {
        set_list_funcionalidades([]);
        if (item != null) {
            set_perfil_Id(item.perfil_Id);
            set_status(item.status);
            setValue("status", item.status, true);
            set_tipo(item.tipo);
            setValue("tipo", item.tipo, true);
            setValue("descricao", item.descricao);
        }
        else {
            set_perfil_Id(0);
            set_status("");
            setValue("status", "", false);
            set_tipo("");
            setValue("tipo", "", false);
            setValue("descricao", "");
        }
    }

    useEffect(() => {
        ValidaAcessoFuncionalidadeAcao("Perfis.Editar", function (result) { set_permiteEditar(result) });
        loadListFuncionalidades();
        loadListSetupSolicitacaoAcao();
        loadItem();
    }, []);

    const onSubmit = (data) => {
        let json_submit = {
            perfil_Id: perfil_Id,
            descricao: data.descricao,
            tipo: tipo,
            status: status,
            UsuarioUltimaAlteracao_Id: session.usuario_Id
        }

        setLoading(true);
        if (json_submit.perfil_Id == 0) {
            api_POST('perfil', json_submit)
                .then(result => { showMessage("Aviso", "Operação executada com sucesso!", 'success', function () { set_perfil_Id(result.data.perfil_Id) }) })
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        }
        else {
            api_PUT('perfil', json_submit)
                .then(result => showMessage("Aviso", "Operação executada com sucesso!", 'success', null))
                .catch(err => showMessage("Aviso", err.message, 'error', null))
                .finally(() => setLoading(false));
        }
    }

    return (
        <>
            <div className="content">

                <Row>
                    <Col md="12">
                        <Button type="button" color="Primary" onClick={Voltar}><i className="fas fa-chevron-left"></i>  Voltar</Button>
                        <Card className="card-user">
                            <CardHeader>
                                <Row><Col md="12" className="text-right"><label className="text-danger">* Campos Obrigatórios</label></Col></Row>
                            </CardHeader>
                            <CardBody>
                                <Nav pills className="nav-pills-primary" style={{ cursor: "pointer" }}>
                                    <NavItem>
                                        <NavLink className={h1_tab === "ht1" ? "link-nav active" : "link-nav"} onClick={() => set_h1_tab("ht1")}><i class="fas fa-users"></i>  Perfil </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink style={{ margin: "0px 10px" }} className={h1_tab === "ht2" ? "link-nav active" : "link-nav"} onClick={() => set_h1_tab("ht2")} ><i class="fas fa-sort-numeric-down"></i>  Lista de Permissões </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink style={{ margin: "0px 10px" }} className={h1_tab === "ht3" ? "link-nav active" : "link-nav"} onClick={() => set_h1_tab("ht3")} ><i class="fas fa-sort-numeric-down"></i>  Acesso às Solicitações </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={h1_tab} className="tab-space tab-principal">
                                    <TabPane tabId="ht1">
                                        <Row>
                                            <Col md="12">
                                                <Form onSubmit={handleSubmit(onSubmit)} className="formPrincipal">
                                                    <Row>
                                                        <Col md="5">
                                                            <FormGroup>
                                                                <b><label><span className="text-danger">*</span> Descrição</label> </b>
                                                                <Input type="text" name="descricao" maxLength={50} innerRef={register({ required: true })} ></Input>
                                                                {errors.descricao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md="3" lg="3">
                                                            <FormGroup>
                                                                <b><label><span className="text-danger">*</span> Tipo</label> </b>
                                                                <Select
                                                                    options={options_tipo}
                                                                    name="tipo"
                                                                    onChange={(e) => { handleTipo(e.value) }}
                                                                    value={tipo != "" && options_tipo.find(obj => obj.value === tipo)}
                                                                    placeholder="Selecione"
                                                                    ref={e => register(
                                                                        { name: "tipo" },
                                                                        { required: true })
                                                                    }
                                                                />
                                                                {errors.tipo && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md="3" lg="3">
                                                            <FormGroup>
                                                                <b><label><span className="text-danger">*</span> Status</label> </b>
                                                                <Select
                                                                    options={options_status}
                                                                    name="status"
                                                                    onChange={(e) => { handleStatus(e.value) }}
                                                                    value={status != "" && options_status.find(obj => obj.value === status)}
                                                                    placeholder="Selecione"
                                                                    ref={e => register(
                                                                        { name: "status" },
                                                                        { required: true })
                                                                    }
                                                                />
                                                                {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col md="12" className="text-center">
                                                            <Button disabled={!permiteEditar} color="success" className="btn-mobile" type="submit"><i className="fas fa-save"></i>  Salvar</Button>
                                                        </Col>
                                                    </Row>
                                                </Form>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="ht2">
                                        <Row>
                                            {list_funcionalidades != null && list_funcionalidades.map((f, key) => {
                                                return <Col className="mt-4" md="12" key={{ key }}>
                                                    <label>{f.descricao}</label>
                                                    <Row>
                                                        {f.funcionalidadeAcoes != null && f.funcionalidadeAcoes.map((a, akey) => {
                                                            return <Col md="4" key={akey}>
                                                                <span>{a.descricao + " "} </span>
                                                                <Switch onChange={(event) => handleChangeFuncionalidadeAcao(a, event)} checked={a.autorizado} height={20} width={35} />
                                                            </Col>
                                                        })}
                                                    </Row>
                                                </Col>
                                            })}
                                        </Row>
                                        <Row>
                                            <Col md="12" className="text-center">
                                                <Button color="success" disabled={!permiteEditar} className="btn-mobile" type="button" onClick={handleSalvarPermissoes}><i className="fas fa-save"></i>  Salvar Permissões</Button>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="ht3">
                                        <Row>
                                            {list_setupsolicitacao != null && list_setupsolicitacao.map((f, key) => {
                                                return <Col className="mt-4" md="12" key={{ key }}>
                                                    <label>{f.descricao}</label>
                                                    <Row>
                                                        {f.solicitacaoAcoes != null && f.solicitacaoAcoes.map((a, akey) => {
                                                            return <Col md="4" key={akey}>
                                                                <span>{a.acao + " "} </span>
                                                                <Switch onChange={(event) => handleChangeSetupSolicitacao(a, event)} checked={a.liberado} height={20} width={35} />
                                                            </Col>
                                                        })}
                                                    </Row>
                                                </Col>
                                            })}
                                        </Row>
                                        <Row>
                                            <Col md="12" className="text-center">
                                                <Button color="success" disabled={!permiteEditar} className="btn-mobile" type="button" onClick={handleSalvarSetupSolicitacao}><i className="fas fa-save"></i>  Salvar Permissões Solicitação</Button>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                </TabContent>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>

        </>
    );
}

